import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c(VAlert,{attrs:{"type":_vm.type,"color":_vm.color,"dark":"","width":_vm.width},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c(VIcon,{on:{"click":_vm.clickClose}},[_vm._v(" mdi-close ")])]},proxy:true}],null,false,2041425708)},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }